import React from 'react'
import { graphql } from 'gatsby'
import Layout from '../components/common/Layout'
import CoursesCourse from '../components/courses/CoursesCourse'

const CoursesCoursePage = ({ data }) => {
  const { course, lessons } = data

  if (!course) {
    return (
      <Layout title="Course Not Found">
        <main>
          <p>Course not found</p>
        </main>
      </Layout>
    )
  }

  const lessonSlugs = course.frontmatter.lessons || []
  const courseSlugPath = course.fields.slug || ''

  const matchedLessons = lessonSlugs
    .map((slug) => {
      const lesson = lessons.nodes.find((l) => {
        const frontmatterSlug = l.frontmatter.slug
        const slugPath = l.fields.slug || ''
        const expectedLessonPath = `${courseSlugPath}${slug}/`
        return (
          frontmatterSlug === slug ||
          slugPath === expectedLessonPath ||
          slugPath.endsWith(`/${slug}/`)
        )
      })
      if (!lesson) return null
      return {
        id: lesson.id,
        title: lesson.frontmatter.title,
        slug: lesson.frontmatter.slug || slug,
        duration: lesson.frontmatter.duration || 0,
        description: lesson.frontmatter.description,
        module: lesson.frontmatter.module,
        moduleOrder: lesson.frontmatter.moduleOrder,
        lessonOrder: lesson.frontmatter.lessonOrder,
        isLab: lesson.frontmatter.isLab
      }
    })
    .filter(Boolean)

  const courseData = {
    title: course.frontmatter.title,
    slug: course.frontmatter.slug,
    description: course.frontmatter.description,
    level: course.frontmatter.level,
    duration: course.frontmatter.durationLabel,
    longDescription: course.frontmatter.longDescription,
    featuredImage:
      course.frontmatter.featuredImage ||
      'https://atlas.co/images/academy-og.png',
    lessons: matchedLessons
  }

  return (
    <Layout
      meta={{
        description:
          courseData.description ||
          'A comprehensive, university-level GIS course on Atlas.',
        title: `${courseData.title} | Atlas Courses`,
        type: 'website',
        absoluteImageUrl: courseData.featuredImage
      }}
      title={courseData.title}
    >
      <main>
        <CoursesCourse courseData={courseData} />
      </main>
    </Layout>
  )
}

export default CoursesCoursePage

export const query = graphql`
  query ($id: String!) {
    course: markdownRemark(id: { eq: $id }) {
      id
      fields {
        slug
      }
      frontmatter {
        title
        slug
        description
        level
        durationLabel
        longDescription
        featuredImage
        lessons
      }
    }
    lessons: allMarkdownRemark(
      filter: {
        fileAbsolutePath: { regex: "/content/courses/" }
        frontmatter: { template: { eq: "CoursesLessonPage" } }
      }
    ) {
      nodes {
        id
        fields {
          slug
        }
        frontmatter {
          title
          slug
          duration
          description
          module
          moduleOrder
          lessonOrder
          isLab
        }
      }
    }
  }
`
